import React from 'react';

const Circle = ({ ...rest }) => (
    <svg viewBox="22 22 44 44" fill="none" {...rest}>
      <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6" />
    </svg>
  );

export default Circle;
